"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = __importDefault(require("lodash"));
var react_1 = __importDefault(require("react"));
var constants_1 = __importDefault(require("../../../../config/constants"));
var styles_1 = __importDefault(require("../styles"));
var SwitchWithFocus_1 = __importDefault(require("./SwitchWithFocus"));
var Preference = function (_a) {
    var item = _a.item, onToggle = _a.onToggle, indent = _a.indent, theme = _a.theme, handlePreferenceDropdownChange = _a.handlePreferenceDropdownChange;
    var classes = (0, styles_1.default)(theme)();
    var _b = react_1.default.useState({}), cstate = _b[0], setCstate = _b[1];
    var _c = react_1.default.useState(false), focused = _c[0], setFocused = _c[1];
    react_1.default.useEffect(function () {
        updateState();
    }, []);
    react_1.default.useEffect(function () {
        updateState();
    }, [item.booleanValue, item.subCategories]);
    var updateState = function () {
        var _a;
        var key = item.key, booleanValue = item.booleanValue, subCategories = item.subCategories;
        var collapseState = lodash_1.default.reduce(subCategories, function (result, subCategory) {
            var _a;
            return (__assign(__assign({}, result), (_a = {}, _a[subCategory.key] = shouldExpand(subCategory.booleanValue, subCategory.subCategories), _a)));
        }, (_a = {},
            _a[key] = shouldExpand(booleanValue, subCategories),
            _a));
        setCstate(collapseState);
    };
    var handleChange = function (event, itemValue) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            handlePreferenceDropdownChange(itemValue, event.target.value);
            return [2];
        });
    }); };
    var toggle = function (key) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, onToggle(key)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var shouldExpand = function (booleanValue, subCategories) {
        if (booleanValue) {
            return true;
        }
        if (!subCategories) {
            return false;
        }
        return lodash_1.default.findIndex(subCategories, function (val) { return !!val.booleanValue; }) >= 0;
    };
    var renderItem = function (itemProps, indentNumber, value, isMainCategory) {
        var _a, _b;
        var booleanValue = itemProps.booleanValue, label = itemProps.label, key = itemProps.key, subCategories = itemProps.subCategories, options = itemProps.options;
        var hasSubCategories = !lodash_1.default.isEmpty(subCategories);
        var sortedSubCategories = lodash_1.default.sortBy(subCategories, function (c) { return !lodash_1.default.isEmpty(c.subCategories); });
        var collapsible;
        var subContent;
        if (hasSubCategories) {
            subContent = (react_1.default.createElement(core_1.List, { disablePadding: true, component: 'div' }, lodash_1.default.map(sortedSubCategories, function (subItem) {
                var _a;
                return renderItem({
                    key: subItem.key,
                    booleanValue: subItem.booleanValue || false,
                    label: (_a = subItem.displayName) !== null && _a !== void 0 ? _a : '',
                    subCategories: subItem.subCategories,
                    options: subItem.options
                }, !lodash_1.default.isEmpty(subItem.subCategories) ? indentNumber * 2 : indentNumber, subItem.value, subItem['mainCat']);
            })));
        }
        else {
            collapsible = react_1.default.createElement("span", { style: { width: 24 } });
        }
        return (react_1.default.createElement(react_1.default.Fragment, { key: "".concat(key, "_fragment") },
            react_1.default.createElement(core_1.ListItem, { component: 'div', className: (0, classnames_1.default)((_a = {},
                    _a[classes.item] = !hasSubCategories,
                    _a[classes.groupItem] = hasSubCategories,
                    _a)), style: {
                    marginLeft: 0,
                    paddingLeft: !isMainCategory ? theme.spacing() * 4 : theme.spacing() * 2,
                    paddingRight: 0
                } },
                react_1.default.createElement(core_1.ListItemText, { disableTypography: true, primary: react_1.default.createElement(core_1.Typography, { variant: hasSubCategories ? 'subtitle2' : 'body2', component: hasSubCategories ? 'h3' : 'p' }, label) }),
                !!options && options.length > 0 ? (react_1.default.createElement(core_1.FormControl, { variant: "filled", className: classes.formControl },
                    react_1.default.createElement(core_1.Select, { id: (value === null || value === void 0 ? void 0 : value.id) ? "menu-item-".concat(value.id) : 'default-menu-item', autoComplete: "off", value: value.id, onChange: function (event) { return handleChange(event, itemProps); } }, options.map(function (opt, index) { return (react_1.default.createElement(core_1.MenuItem, { key: opt.id || index, value: opt.id }, opt.displayName)); })))) : constants_1.default.ACCESSIBLE_PREFERENCE_SWITCH ? (react_1.default.createElement(SwitchWithFocus_1.default, { label: label, checked: booleanValue, onChange: function () { return toggle(key); }, divCssStyle: classes.cssDiv })) : (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'row' } },
                    react_1.default.createElement(core_1.Switch, { inputProps: {
                            'aria-label': itemProps.label,
                            style: { padding: 0 }
                        }, onChange: function () { return toggle(key); }, checked: booleanValue }),
                    collapsible))),
            react_1.default.createElement(core_1.Divider, { className: (0, classnames_1.default)((_b = {},
                    _b[classes.groupDivider] = hasSubCategories,
                    _b)), style: {
                    marginLeft: !isMainCategory ? theme.spacing() * 4 : theme.spacing() * 2,
                    paddingLeft: 0
                } }),
            subContent));
    };
    return renderItem(item, indent || 1, cstate, true);
};
exports.default = Preference;
//# sourceMappingURL=Preference.js.map